import { TPartialVersionedResource } from "app/queryProvider/interfaces";

export const pathwayVersionedResource: TPartialVersionedResource<"pathways" | "appointments" | "exams"> = {
  pathways: {
    name: "pathways",
    version: "v1",
    microService: "rpm",
    serializer: null,
  },
  appointments: {
    name: "appointments",
    version: "v1",
    microService: "rpm",
    serializer: null,
  },
  exams: {
    name: "exams",
    version: "v1",
    microService: "rpm",
    serializer: null,
  },
};

const routes = {
  pathways: {
    activate: (pathwayId: string) =>
      `/rpm/api/v1/pathways/${pathwayId}/activate` as const,
  },
} as const;

export { routes };